import React, { useState } from 'react'
import { Tabs, Tab } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { CenteredLayout } from './shared/CenteredLayout'
import PlaceHolder from '../components/contentConfiguration/PlaceHolder'
import { ContentTitle } from '../components/shared/ContentTitle'

const useStyles = makeStyles(() => ({
    tabs: {
        border: '1px solid #ccc',
        backgroundColor: '#fff',
        marginBottom: '10px',
    },
    bodySection: {
        marginBottom: '30px',
    },
}))

export function ContentConfigurationPage() {
    const classes = useStyles()
    const tabValues = {
        PLACEHOLDER: 0,
    }

    const [tabValue, setTabValue] = useState(tabValues.PLACEHOLDER)

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue)
    }

    const TabView = () => {
        switch (tabValue) {
            case tabValues.PLACEHOLDER:
                return <PlaceHolder />
            default:
                return <PlaceHolder />
        }
    }

    return (
        <CenteredLayout>
            <ContentTitle pageTitle={'Content'} />

            <div
                style={{ justifyContent: 'center' }}
                className={classes.topBarSection}>
                <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    indicatorColor='secondary'
                    textColor='secondary'
                    variant='fullWidth'
                    className={classes.tabs}>
                    <Tab label='PlaceHolder' />
                    <Tab label='PlaceHolder' />
                    <Tab label='PlaceHolder' />
                </Tabs>
            </div>
            <div className={classes.bodySection}>
                <TabView />
            </div>
        </CenteredLayout>
    )
}
